import axios from 'axios';
import { useState, useEffect } from 'react';
import { obtainURL,obtainURLBackendClay } from '../../common/obtainURL';
import {exportarDetalleAExcel } from '../../common/utils'
import { createHeader } from '../../common/auth';
import * as XLSX from "xlsx";
import {
  IonCol,
  IonButton,
  IonDatetimeButton,
  IonDatetime,
  IonRow,
  IonCard,
  IonIcon,
  IonItem,
  IonLabel,
  IonModal,
  IonLoading,
  IonCardHeader,

  IonHeader,
  IonToolbar,
  IonGrid,
  IonProgressBar,
  IonContent,
  IonCardContent,
  IonTitle,
  IonButtons,
  IonPage,
  IonInput,
  IonSelectOption,
  IonSelect,
  IonCardSubtitle,
  IonAlert,
  IonCheckbox,
  IonSpinner
} from '@ionic/react';
import { cashOutline, statsChartOutline, logoEuro, trash, closeOutline, fileTrayOutline, downloadOutline  } from 'ionicons/icons';
import 'react-data-grid/lib/styles.css';
let URL = obtainURL();
let URL_CLAY= obtainURLBackendClay();
// Tipos
export type MontoPorMoneda = {
  CLP: number;
  UF: number ;
  USD: number ;
  EUR: number ;
};

export interface SemanaData {
  semana: string;
  pagar: MontoPorMoneda;
  cobrar: MontoPorMoneda;
  saldo: MontoPorMoneda;
  total: MontoPorMoneda;
  balanceBanco: MontoPorMoneda;
  manuales: {
    descripcion: string;
    montos: MontoPorMoneda;
  }[];
}

type TipoDato = "pagar" | "cobrar" | "balanceBanco";

interface TotalesSemana {
  semana: string;
  porPagar: number;
  porCobrar: number;
  total: number;
  saldoDisponible: number;
}


type SemanaAgrupada = {
  mes: string;
  semanas: string[];
};
type PagoFuturo = {
  empresa: string;
  item: string;
  fecha: string; // formato ISO: "2024-06-20"
  monto: number;
  moneda: "" | keyof MontoPorMoneda;
};

interface FlujoEmpresa {
  empresa: string;
  rut: string;
  data: SemanaData[];
}
type EmpresaData = {
  name: string;
  value: {
    tipo: string;
    semanas: {
      semana: string;
      montoFactura: number;
      pagado: number;
    }[];
  };
};

const CompromisoPagoModulo = () => {
  const [loadingDetalle, setLoadingDetalle] = useState(false);
  const [pagosFuturos, setPagosFuturos] = useState<PagoFuturo[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [item, setItem] = useState("");
  const [fecha, setFecha] = useState("");
  const [moneda, setMoneda] = useState<keyof MontoPorMoneda | "">("");
  const [monto, setMonto] = useState<number>(0);
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState<string>("");
  const [resumenGlobal, setResumenGlobal] = useState<TotalesSemana | null>(null);
  const [loading, setLoading] = useState(true);
   const [loadingVencidas, setLoadingVencidas] = useState(true);
      const [isLoadingVencidas, setIsLoadingVencidas] = useState(false); // Loader interno

  //modal detalle
  const [modalDetalleOpen, setModalDetalleOpen] = useState(false);
  const [detalleSemana, setDetalleSemana] = useState<string>('');
  const [detalleTipo, setDetalleTipo] = useState<string>('');
  const [flujoDataPorEmpresa, setFlujoDataPorEmpresa] = useState<FlujoEmpresa[]>([]);
  const [detalleEmpresaSeleccionada, setDetalleEmpresaSeleccionada] = useState<any[]>([]);
  const [detalleEmpresa, setDetalleEmpresa] = useState<string>("");
  const [empresasDisponibles, setEmpresasDisponibles] = useState<{ nombre: string; rut: string }[]>([]);
  const [alerta, setAlerta] = useState<{ mensaje: string;abierto: boolean;}>({mensaje: "",abierto: false,});
 const [alertaExcepcion, setAlertaExcepcion] = useState<{ mensaje: string;abierto: boolean;}>({mensaje: "",abierto: false,});
  // Modal de detalle bancario
  const [modalDetalleBancarioOpen, setModalDetalleBancarioOpen] = useState(false);
const [detalleBancarioSemana, setDetalleBancarioSemana] = useState<SemanaData | null>(null);
  const [detalleBancarioEmpresa, setDetalleBancarioEmpresa] = useState<string>('');

  const [folioSeleccionado, setFolioSeleccionado] = useState<string | null>(null);
  const [fechaReprogramada, setFechaReprogramada] = useState<string>("");
  const [motivoExcepcion, setMotivoExcepcion] = useState<string>("");
  const [guardandoExcepcion, setGuardandoExcepcion] = useState<boolean>(false);
  const [modalVencidasOpen, setModalVencidasOpen] = useState(false);
  const [facturasVencidas, setFacturasVencidas] = useState<any[]>([]);


const [paginaActual, setPaginaActual] = useState(1);
const itemsPorPagina = 10;

const facturasFlattened = facturasVencidas.flatMap((empresa) =>
  empresa?.value?.map((item: any) => ({
    ...item,
    empresaName: empresa.name,
  })) || []
);

const totalPaginas = Math.ceil(facturasFlattened.length / itemsPorPagina);

const facturasPagina = facturasFlattened.slice(
  (paginaActual - 1) * itemsPorPagina,
  paginaActual * itemsPorPagina
);



  // Hoy
  const fechaHoyModal = new Date();

  // Lunes de esta semana
  const lunesActual = obtenerLunesBase(fechaHoyModal);

  // Domingo de la semana 12 (lunes + (12*7 -1) días)
  const domingoSemana12 = new Date(lunesActual);
  domingoSemana12.setDate(lunesActual.getDate() + 12 * 7 - 1);

  // Convertir a ISO (para el IonDatetime)
  const fechaMinISO = lunesActual.toISOString();
  const fechaMaxISO = domingoSemana12.toISOString();


  useEffect(() => {
    fetchDataFromEndpoint();
  }, []);

  const fetchDataFromEndpoint = async () => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem("user") || "{}").token;
      const fechaActual = new Date();
      const yyyy = fechaActual.getFullYear();
      const mm = String(fechaActual.getMonth() + 1).padStart(2, '0');
      const dd = String(fechaActual.getDate()).padStart(2, '0');
      const fechaHasta = `${yyyy}-${mm}-${dd}`;

      const res = await axios.get(`${URL}/get-detalle-compromiso-pago-semana?date=${fechaHasta}`, createHeader(token));
      const rawData = res.data.data;

      console.log("el servicio sin modificar", rawData);

      const primerDia = obtenerPrimerDiaMinimo(rawData);
      const semanas = generarSemanasDesde(primerDia, 12);
      const flujo = transformarDatosSemana(rawData, semanas);


      const flujoActualizado = await fetchSaldosBancarios(flujo);
      console.log("DESPUÉS DE SALDOS", flujoActualizado);
 

        setFlujoDataPorEmpresa(flujoActualizado);
    } catch (error) {
      console.error("Error al obtener los datos reales del endpoint:", error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    const fetchEmpresas = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("user") || "{}").token;
        const res = await axios.get(`${URL_CLAY}/empresas`, createHeader(token));
        const empresas = res.data?.data?.response?.[1] ?? [];
            const empresasMapeadas = empresas.map((e: any) => ({
          nombre: e.shortName, 
          rut: e.rut
        }));
        setEmpresasDisponibles(empresasMapeadas);
      
      } catch (error) {
        console.error("Error al cargar empresas:", error);
      }
    };

    fetchEmpresas();
  }, []);

  function obtenerPrimerDiaMinimo(dataOriginal: any[]): Date {
    let fechas: Date[] = [];

    dataOriginal.forEach((empresaObj) => {
      const monedas = empresaObj.value?.monedas || {};
      Object.values(monedas).forEach((items) => {
        if (Array.isArray(items)) {
          items.forEach((item: any) => {
            const [fechaStr] = item.semana.split(" - ");
            const partes = fechaStr.split("/");
            if (partes.length === 3) {
              const fecha = new Date(+partes[2], +partes[1] - 1, +partes[0]);
              fechas.push(fecha);
            }
          });
        }
      });
    });

    return fechas.length > 0 ? new Date(Math.min(...fechas.map((f) => f.getTime()))) : new Date();
  }


 function exportarTablaCompromisos(flujoDataPorEmpresa: FlujoEmpresa[], semanas: string[]) {
   const worksheetData: any[][] = [];

  // 🚀 Encabezados
  const headerRow = ["Empresa", "Tipo", ...semanas];
  worksheetData.push(headerRow);

  // 🚀 Por cada empresa
  flujoDataPorEmpresa.forEach(({ empresa, data }) => {
    const tiposBase: (keyof SemanaData | "balanceBanco" | "manual")[] = [
      "saldo",
      "pagar",
      "cobrar",
      "balanceBanco",
      "total",
    ];

    const manualesUnicos: string[] = Array.from(
      new Set(
        data.flatMap((s: SemanaData) =>
          s.manuales?.map((m) => m.descripcion) ?? []
        )
      )
    );

    // Por cada tipo base
    tiposBase.forEach((tipo) => {
      const fila: any[] = [];
      fila.push(empresa);
      fila.push(
        tipo === "saldo"
          ? "Saldo Disponible"
          : tipo === "pagar"
          ? "A Pagar"
          : tipo === "cobrar"
          ? "A Cobrar"
          : tipo === "balanceBanco"
          ? "Balance Bancario"
          : "Total"
      );

      semanas.forEach((semana) => {
        const semanaData = data.find((s: SemanaData) => s.semana === semana);
        let valores: MontoPorMoneda = {
          CLP: 0,
          UF: 0,
          USD: 0,
          EUR: 0,
        };

        if (tipo === "saldo") valores = semanaData?.saldo ?? valores;
        else if (tipo === "pagar") valores = semanaData?.pagar ?? valores;
        else if (tipo === "cobrar") valores = semanaData?.cobrar ?? valores;
        else if (tipo === "total") valores = semanaData?.total ?? valores;
        else if (tipo === "balanceBanco")
          valores =
            semanaData?.balanceBanco ??
            (semana === semanas[0] ? valores : { CLP: 0, UF: 0, USD: 0, EUR: 0 });

        fila.push(
          `UF:${valores.UF} | CLP:${valores.CLP} | USD:${valores.USD} | EUR:${valores.EUR}`
        );
      });

      worksheetData.push(fila);
    });

    // 🚀 Por cada manual
    manualesUnicos.forEach((manualDesc) => {
      const fila: any[] = [];
      fila.push(empresa);
      fila.push(manualDesc);

      semanas.forEach((semana) => {
        const semanaData = data.find((s: SemanaData) => s.semana === semana);
        const manual = semanaData?.manuales?.find(
          (m) => m.descripcion === manualDesc
        );
        const montos = manual?.montos ?? { CLP: 0, UF: 0, USD: 0, EUR: 0 };
        fila.push(
          `UF:${montos.UF} | CLP:${montos.CLP} | USD:${montos.USD} | EUR:${montos.EUR}`
        );
      });

      worksheetData.push(fila);
    });

    // 🚀 Fila vacía como separador
    worksheetData.push([]);
  });

  // Crear workbook
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(worksheetData);

  // Opcional: ajustar el ancho de columnas
  ws["!cols"] = headerRow.map(() => ({ wch: 30 }));

  // Crear el archivo
  XLSX.utils.book_append_sheet(wb, ws, "Compromisos");
    const hoy = new Date();
    const yyyy = hoy.getFullYear();
    const mm = String(hoy.getMonth() + 1).padStart(2, "0");
    const dd = String(hoy.getDate()).padStart(2, "0");
    const fechaHoy = `${yyyy}-${mm}-${dd}`;

    // Generar el nombre del archivo
    const nombreArchivo = `flujo-${fechaHoy}.xlsx`;

    // Guardar el archivo
    XLSX.writeFile(wb, nombreArchivo);
    }



function generarSemanas(fechaInicio: Date, cantidad: number): string[] {
  const semanas: string[] = [];

  for (let i = 0; i < cantidad; i++) {
    const inicio = new Date(fechaInicio);
    inicio.setDate(inicio.getDate() + i * 7);

    const fin = new Date(inicio);
    fin.setDate(inicio.getDate() + 6);

    const format = (d: Date) =>
      d.toLocaleDateString("es-CL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }).split("/").join("-"); // "dd-mm-yyyy"

    semanas.push(`${format(inicio)} - ${format(fin)}`);
  }

  return semanas;
}


  function obtenerLunesBase(fecha: Date): Date {
    const dia = fecha.getDay();
    const diferencia = dia === 0 ? -6 : 1 - dia;
    const lunes = new Date(fecha);
    lunes.setDate(fecha.getDate() + diferencia);
    lunes.setHours(0, 0, 0, 0);
    return lunes;
  }

  const fechaHoy = new Date();
  const fechaBase = obtenerLunesBase(fechaHoy);
  const semanas = generarSemanas(fechaBase, 12);

  function obtenerNombreMes(mes: number): string {
    const nombres = [
      "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];
    return nombres[mes - 1];
  }

function agruparSemanasPorMes(fechas: string[]): SemanaAgrupada[] {
  const meses: { [key: string]: string[] } = {};

  fechas.forEach((semanaCompleta) => {
    const [dia, mes, anio] = semanaCompleta.split(" - ")[0].split("-");
    const mesNombre = obtenerNombreMes(parseInt(mes, 10));
    if (!meses[mesNombre]) meses[mesNombre] = [];
    meses[mesNombre].push(semanaCompleta);
  });

  return Object.entries(meses).map(([mes, semanas]) => ({ mes, semanas }));
}


  const semanasAgrupadas = agruparSemanasPorMes(semanas);




const guardarPagoFuturo = async () => {
  if (!empresaSeleccionada || !moneda || !item || !fecha || monto <= 0) {
    alert("Completa todos los campos antes de guardar");
    return;
  }

  const empresaData = empresasDisponibles.find(e => e.rut === empresaSeleccionada);
  if (!empresaData) {
    alert("La empresa seleccionada no se encontró en la lista.");
    return;
  }

  const usuario = JSON.parse(localStorage.getItem("user") || "{}");
  const email = usuario?.email || "UsuarioDesconocido";

  // Formatea la fecha
  const fechaObj = new Date(fecha);
  const dia = String(fechaObj.getDate()).padStart(2, "0");
  const mes = String(fechaObj.getMonth() + 1).padStart(2, "0");
  const anio = fechaObj.getFullYear();
  const fechaFormateada = `${anio}-${mes}-${dia}`;

  const nuevoPago = {
    item,
    monto,
    fechaPago: fechaFormateada,
    user: email,
    rut: empresaData.rut,
    moneda
  };

  const token = usuario?.token;

  try {
    console.log("obj q envio :", nuevoPago);

    const res = await axios.post(`${URL}/insert-compromiso-pago`, nuevoPago, createHeader(token));
     await fetchDataFromEndpoint();
    // Resetea campos
    setEmpresaSeleccionada("");
    setItem("");
    setFecha("");
    setMonto(0);
    setMoneda("");
    setModalOpen(false);
          setAlerta({
        mensaje: "Pago futuro guardado correctamente.",
        abierto: true,
      });
  } catch (error: any) {
    console.error(" Error al guardar el pago futuro:", error);
 
      if (error.response?.data?.message) {
        setAlerta({
          mensaje: `Error: ${error.response.data.message}`,
          abierto: true,
        });
      } else {
        setAlerta({
          mensaje: "Ocurrió un error al guardar el pago futuro.",
          abierto: true,
        });
      }
        }
};




  const formatear = (valor: number | undefined) =>
    valor !== undefined ? valor.toLocaleString("es-CL") : "--";





const getEmptyMonto = (): MontoPorMoneda => ({
  CLP: 0,
  UF: 0,
  USD: 0,
  EUR: 0,
});



const handleClickDetalle = async (empresa: string, tipo: 'S' | 'C', semana: string) => {
  try {
    setDetalleEmpresa(empresa);
    setDetalleSemana(semana);
    setDetalleTipo(tipo);
    setDetalleEmpresaSeleccionada([]); 
    setLoadingDetalle(true);
    setModalDetalleOpen(true);

    // Extraer fecha inicio y fin de la semana
    const [inicio, fin] = semana.split(" - "); // ej: ["04-08-2025", "10-08-2025"]
    const [diaInicio, mesInicio, anioInicio] = inicio.split("-");
    const [diaFin, mesFin, anioFin] = fin.split("-");

    const fechaInicio = new Date(`${anioInicio}-${mesInicio}-${diaInicio}`);
    const fechaFin = new Date(`${anioFin}-${mesFin}-${diaFin}`);
    fechaFin.setHours(23, 59, 59, 999);
   

   const hoy = new Date();
   const fechaFormateada = hoy.toISOString().split("T")[0]; 

    const token = JSON.parse(localStorage.getItem("user") || "{}").token;

    const res = await axios.get(
      `${URL}/get-detalle-compromiso-pago-global?date=${fechaFormateada}`,
      createHeader(token)
    );

    const data = res.data?.data || [];
    const empresaData = data.find((e: any) => e.name === empresa);
    const facturas = empresaData?.value || [];

  

    // Filtro por tipo y vencimiento entre inicio y fin
    const dataFiltrada =facturas.filter((item: any) => {
  const vencimientoStr = item["Fecha Vencimiento"];
  const vencimientoDate = new Date(
    vencimientoStr.slice(0, 4) + "-" + vencimientoStr.slice(4, 6) + "-" + vencimientoStr.slice(6, 8)
  );

  const entra =
    item.TIPO === tipo &&
    vencimientoDate >= fechaInicio &&
    vencimientoDate <= fechaFin;

  return entra;
});

    console.log(" Facturas filtradas:", dataFiltrada);
    setDetalleEmpresaSeleccionada(dataFiltrada);

  } catch (err) {
    console.error("❌ Error al obtener el detalle de compromiso:", err);
  } finally {
    setLoadingDetalle(false);
  }
};






function generarSemanasDesde(fechaInicio: Date, cantidad: number): string[] {
  const semanas: string[] = [];
  fechaInicio.setHours(0, 0, 0, 0);

  for (let i = 0; i < cantidad; i++) {
    const inicio = new Date(fechaInicio);
    inicio.setDate(fechaInicio.getDate() + i * 7);

    const fin = new Date(inicio);
    fin.setDate(inicio.getDate() + 6);

    const format = (d: Date) =>
      d.toLocaleDateString("es-CL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

    semanas.push(`${format(inicio)} - ${format(fin)}`);
  }

  return semanas;
}
const transformarDatosSemana = (dataOriginal: any[], semanas: string[]): FlujoEmpresa[] => {
  const empresasMap: Record<string, SemanaData[]> = {};

  const symbolToMoneda: Record<string, keyof MontoPorMoneda> = {
    "$": "CLP",
    "CLP": "CLP",
    "USD": "USD",
    "UF": "UF",
    "EUR": "EUR",
  };

  const normalizarSemana = (semana: string): string => {
    if (!semana || typeof semana !== "string") return "";
    const [inicio, fin] = semana.split(" - ");
    const toDashFormat = (fecha: string) => {
      const partes = fecha.split("/");
      return partes.length === 3
        ? `${partes[0].padStart(2, "0")}-${partes[1].padStart(2, "0")}-${partes[2]}`
        : fecha;
    };
    if (!inicio || !fin) return "";
    return `${toDashFormat(inicio)} - ${toDashFormat(fin)}`;
  };

  const inicializarData = (): SemanaData[] =>
    semanas.map((semana) => ({
      semana,
      pagar: { CLP: 0, UF: 0, USD: 0, EUR: 0 },
      cobrar: { CLP: 0, UF: 0, USD: 0, EUR: 0 },
      saldo: { CLP: 0, UF: 0, USD: 0, EUR: 0 },
      total: { CLP: 0, UF: 0, USD: 0, EUR: 0 },
      balanceBanco: { CLP: 0, UF: 0, USD: 0, EUR: 0 },
      manuales: [],
    }));

  // Procesar datos normales
  dataOriginal.forEach((empresaObj) => {
    if (!empresaObj.value) return;

    const { rut, name, value } = empresaObj;
    const tipo = value?.tipo;
    const monedas = value?.monedas || {};

    const clave = rut + "_" + name;
    if (!empresasMap[clave]) {
      empresasMap[clave] = inicializarData();
    }

    Object.entries(monedas).forEach(([simbolo, items]) => {
      const mappedMoneda = symbolToMoneda[simbolo];
      if (!mappedMoneda || !Array.isArray(items)) return;

      items.forEach((item: any) => {
        const semanaFormateada = normalizarSemana(item.semana);
        const semanaIndex = semanas.indexOf(semanaFormateada);
        if (semanaIndex === -1) return;

        const semanaData = empresasMap[clave][semanaIndex];
        if (!semanaData) return;

        const campo = tipo === "S" ? "pagar" : tipo === "C" ? "cobrar" : null;
        if (!campo) return;

        const bloque = semanaData[campo as keyof SemanaData] as MontoPorMoneda;
        const valorActual = bloque[mappedMoneda];

        const montoBase = Number(item.montoFactura) || 0;
        const pagadoBase = Number(item.pagado) || 0;
        const neto = montoBase - pagadoBase;
        const nuevoValor = tipo === "S" ? -neto : neto;

        bloque[mappedMoneda] =
          typeof valorActual === "number"
            ? valorActual + nuevoValor
            : nuevoValor;
      });
    });
  });

  // Procesar dataManual
  const dataManual = dataOriginal
    .filter((x) => x.dataManual)
    .flatMap((x) => x.dataManual) ?? [];

  dataManual.forEach((empresaManual: any) => {
    const rut = empresaManual.rut;
    const monedas = empresaManual.monedas || {};

    const clavesExistentes = Object.keys(empresasMap).filter((k) =>
      k.startsWith(rut + "_")
    );
    if (clavesExistentes.length === 0) {
      console.warn("No se encontró empresa para rut:", rut);
      return;
    }

    Object.entries(monedas).forEach(([simbolo, items]) => {
      const mappedMoneda = symbolToMoneda[simbolo];
      if (!mappedMoneda || !Array.isArray(items)) return;

      items.forEach((item: any) => {
        const semanaFormateada = normalizarSemana(item.semana);

        if (!semanas.includes(semanaFormateada)) {
          semanas.push(semanaFormateada);
        }

        clavesExistentes.forEach((claveExistente) => {
          let semanaData = empresasMap[claveExistente].find(
            (s) => s.semana === semanaFormateada
          );

          if (!semanaData) {
            semanaData = {
              semana: semanaFormateada,
              pagar: { CLP: 0, UF: 0, USD: 0, EUR: 0 },
              cobrar: { CLP: 0, UF: 0, USD: 0, EUR: 0 },
              saldo: { CLP: 0, UF: 0, USD: 0, EUR: 0 },
              total: { CLP: 0, UF: 0, USD: 0, EUR: 0 },
              balanceBanco: { CLP: 0, UF: 0, USD: 0, EUR: 0 },
              manuales: [],
            };
            empresasMap[claveExistente].push(semanaData);
          }

          // Sumar manual agrupando por descripción
          let manualExistente = semanaData.manuales.find(
            (m) => m.descripcion === item.descripcion
          );

          if (!manualExistente) {
            manualExistente = {
              descripcion: item.descripcion || "Manual",
              montos: {
                CLP: 0,
                UF: 0,
                USD: 0,
                EUR: 0,
              },
            };
            semanaData.manuales.push(manualExistente);
          }

          manualExistente.montos[mappedMoneda] += item.monto;
        });
      });
    });
  });

  // Preparar retorno
  const empresasUnicas = Object.keys(empresasMap);
  return empresasUnicas.map((clave) => {
    const [rut, name] = clave.split("_");
    return {
      empresa: name,
      rut,
      data: empresasMap[clave] ?? inicializarData(),
    };
  });
};


const fetchSaldosBancarios = async (flujo: FlujoEmpresa[]): Promise<FlujoEmpresa[]> => {
  try {
    const token = JSON.parse(localStorage.getItem("user") || "{}").token;

    const ayer = new Date();
    const diaSemana = ayer.getDay();

    if (diaSemana === 1) {
      ayer.setDate(ayer.getDate() - 3);
    } else {
      ayer.setDate(ayer.getDate() - 1);
    }

    const yyyy = ayer.getFullYear();
    const mm = String(ayer.getMonth() + 1).padStart(2, "0");
    const dd = String(ayer.getDate()).padStart(2, "0");
    const fechaAyer = `${yyyy}-${mm}-${dd}`;

    const res = await axios.get(
      `${URL_CLAY}/cuentas/saldos/empresa-moneda?date=${fechaAyer}`,
      createHeader(token)
    );

    const saldos = res.data?.data?.response?.[1] || [];
   console.log("saldo",saldos)
    const flujoActualizado = flujo.map((empresa) => {
      const saldoEmpresa = saldos.find((s: any) => s.rut === empresa.rut);
      if (!saldoEmpresa) return empresa;

      const primeraSemana = empresa.data[0];
      if (!primeraSemana) return empresa;

      if (!primeraSemana.balanceBanco) {
        primeraSemana.balanceBanco = { CLP: 0, USD: 0, EUR: 0, UF: 0 };
      }

      saldoEmpresa.value.forEach((monedaObj: any) => {
        const moneda = monedaObj.moneda as keyof MontoPorMoneda;
        const total = monedaObj.total || 0;
        primeraSemana.balanceBanco![moneda] = total;
      });

      return empresa;
    });

    // 🚀 Recalcular saldos y totales
    flujoActualizado.forEach((empresa) => {
      empresa.data.forEach((semana, i) => {
        // Paso 1: Definir el saldo disponible (es el total anterior)
        let saldoDisponible: MontoPorMoneda;
        if (i === 0) {
          saldoDisponible = { CLP: 0, UF: 0, USD: 0, EUR: 0 };
        } else {
          saldoDisponible = { ...empresa.data[i - 1].total };
        }
        semana.saldo = saldoDisponible;

        // Paso 2: Inicializar total con saldo disponible
        const total: MontoPorMoneda = { ...saldoDisponible };

        // Sumar pagar y cobrar
        ["pagar", "cobrar"].forEach((campo) => {
          const bloque = semana[campo as keyof SemanaData];
          if (bloque) {
            Object.entries(bloque).forEach(([moneda, valor]) => {
              const key = moneda as keyof MontoPorMoneda;
              total[key] += valor;
            });
          }
        });

        // resto los items manuales
        if (semana.manuales && semana.manuales.length > 0) {
          semana.manuales.forEach((manual) => {
            Object.entries(manual.montos).forEach(([moneda, valor]) => {
              const key = moneda as keyof MontoPorMoneda;
              total[key] -= valor;
            });
          });
        }

        // Sumar balanceBanco SOLO en la primera semana
        if (i === 0 && semana.balanceBanco) {
          Object.entries(semana.balanceBanco).forEach(([moneda, valor]) => {
            const key = moneda as keyof MontoPorMoneda;
            total[key] += valor;
          });
        }

        // Guardar total
        semana.total = total;
      });
    });

    return flujoActualizado;

  } catch (err) {
    console.error("Error al obtener saldos bancarios:", err);
    return flujo;
  }
};


const guardarExcepcionFactura = async () => {
  setGuardandoExcepcion(true);
  try {
    const usuario = JSON.parse(localStorage.getItem("user") || "{}");
    const token = usuario?.token;
    const email = usuario?.email || "UsuarioDesconocido";

    //busco rut  en flujoDataPorEmpresa
    const empresaObj = flujoDataPorEmpresa.find(e => e.empresa === detalleEmpresa);
    const rut = empresaObj?.rut || "";

    // formateo nueva fecha
    const fechaObj = new Date(fechaReprogramada);
    const dia = String(fechaObj.getDate()).padStart(2, "0");
    const mes = String(fechaObj.getMonth() + 1).padStart(2, "0");
    const anio = fechaObj.getFullYear();
    const nvaFechaFormateada = `${anio}-${mes}-${dia}`;

    // la factura seleccionada para obtener su fecha original
    const facturaSeleccionada = detalleEmpresaSeleccionada.find(f => f.Folio === folioSeleccionado);
    
    const fechaPagoOriginalRaw = facturaSeleccionada?.["Fecha Vencimiento"] || "";
    let fechaPagoOriginalFormateada = "";
    if (fechaPagoOriginalRaw && fechaPagoOriginalRaw.length === 8) {
      const anio = fechaPagoOriginalRaw.slice(0,4);
      const mes = fechaPagoOriginalRaw.slice(4,6);
      const dia = fechaPagoOriginalRaw.slice(6,8);
      fechaPagoOriginalFormateada = `${anio}-${mes}-${dia}`;
    }

    const payload = {
      description: motivoExcepcion,
      fechaPago: fechaPagoOriginalFormateada,
      nvaFecha: nvaFechaFormateada,
      user: email,
      rut: rut,
      folio: facturaSeleccionada.Folio,
      cardName: facturaSeleccionada.CardName,
      montoFactura: facturaSeleccionada["MONTO FACTURA"],
      money: facturaSeleccionada.MONEDA
    };

    console.log("Payload que se envioooo:", payload);

    await axios.post( `${URL}/insert-postergar-cobro`,payload,createHeader(token));

  // Mostramos alerta pero NO llamamos aún a fetchData ni cerramos el modal
   setAlertaExcepcion({
  mensaje: "Factura reprogramada correctamente.",
  abierto: true,
});

   // await fetchDataFromEndpoint();

    // Resetear formulario
    //setFolioSeleccionado(null);
    //setFechaReprogramada("");
    //setMotivoExcepcion("");
  } catch (err) {
    console.error("Error al reprogramar factura:", err);
    setAlertaExcepcion({
      mensaje: "Ocurrió un error al reprogramar la factura.",
      abierto: true,
    });
  } finally {
    setGuardandoExcepcion(false);
  }
};

const guardarExcepcionFacturaVencidas = async () => {
  setGuardandoExcepcion(true);
  try {
    const usuario = JSON.parse(localStorage.getItem("user") || "{}");
    const token = usuario?.token;
    const email = usuario?.email || "UsuarioDesconocido";

    // 🔍 Buscamos la empresa y la factura seleccionada
    const empresaObj = facturasVencidas.find(empresa =>
      empresa.value?.some((factura: any) => factura.Folio === folioSeleccionado)
    );

    if (!empresaObj) throw new Error("No se encontró la empresa para la factura seleccionada.");

    const facturaSeleccionada = empresaObj.value.find(
      (factura: any) => factura.Folio === folioSeleccionado
    );

    if (!facturaSeleccionada) throw new Error("No se encontró la factura seleccionada.");

    const rut = empresaObj.rut;

    // 📅 Formateo fechas
    const fechaObj = new Date(fechaReprogramada);
    const nvaFechaFormateada = `${fechaObj.getFullYear()}-${String(fechaObj.getMonth() + 1).padStart(2, "0")}-${String(fechaObj.getDate()).padStart(2, "0")}`;

    let fechaPagoOriginalFormateada = "";
    const raw = facturaSeleccionada["Fecha Vencimiento"];
    if (raw && raw.length === 8) {
      const anio = raw.slice(0, 4);
      const mes = raw.slice(4, 6);
      const dia = raw.slice(6, 8);
      fechaPagoOriginalFormateada = `${anio}-${mes}-${dia}`;
    }

    // 📦 Armamos el payload
    const payload = {
      description: motivoExcepcion,
      fechaPago: fechaPagoOriginalFormateada,
      nvaFecha: nvaFechaFormateada,
      user: email,
      rut: rut,
      folio: facturaSeleccionada.Folio,
      cardName: facturaSeleccionada.CardName,
      montoFactura: facturaSeleccionada["MONTO FACTURA"],
      money: facturaSeleccionada.MONEDA
    }

    console.log("Payload que se envía:", payload);

    await axios.post(`${URL}/insert-postergar-cobro`, payload, createHeader(token));

    setAlertaExcepcion({
      mensaje: "Factura reprogramada correctamente.",
      abierto: true,
    });

    // Opcional: eliminamos la factura reprogramada del listado
        const nuevasFacturas = facturasVencidas.map((empresa) => ({
        ...empresa,
        value: Array.isArray(empresa.value)
          ? empresa.value.filter((f: any) => f.Folio !== folioSeleccionado)
          : []
      })).filter(e => e.value.length > 0);

    setFacturasVencidas(nuevasFacturas);
    setFolioSeleccionado(null);
    setFechaReprogramada("");
    setMotivoExcepcion("");

  } catch (err: any) {
    console.error("Error al reprogramar factura:", err);
    setAlertaExcepcion({
      mensaje: err.message || "Ocurrió un error al reprogramar la factura.",
      abierto: true,
    });
  } finally {
    setGuardandoExcepcion(false);
  }
};




const toggleSeleccionExcepcion = (checked: boolean, folio: string) => {
  if (checked) {
    setFolioSeleccionado(folio);
  } else {
    setFolioSeleccionado(null);
    setFechaReprogramada("");
    setMotivoExcepcion("");
  }
};
    

const handleClickVencidas = async () => {
  try {
    const token = JSON.parse(localStorage.getItem("user") || "{}").token;
    const hoy = new Date();
    const yyyy = hoy.getFullYear();
    const mm = String(hoy.getMonth() + 1).padStart(2, "0");
    const dd = String(hoy.getDate()).padStart(2, "0");
    const fechaHoy = `${yyyy}-${mm}-${dd}`;

    // 🔥 Abrimos modal de una
    setModalVencidasOpen(true);
    setIsLoadingVencidas(true);

    const res = await axios.get(
      `${URL}/get-detalle-compromiso-pago-vencidos?date=${fechaHoy}`,
      createHeader(token)
    );

    const data = res.data?.data || [];
    setFacturasVencidas(data);
  } catch (error) {
    console.error("Error al obtener vencidas:", error);
    setAlerta({
      mensaje: "No se pudieron cargar las facturas vencidas.",
      abierto: true,
    });
  } finally {
    setIsLoadingVencidas(false);
  }
};


    return (
  
    <IonPage>
       <IonLoading
        isOpen={loading}
        message="Cargando compromisos de pago..."
        spinner="circles"
      />
      <IonContent>
          {!loading && (
        <IonCard>
          <IonCardHeader>
                <IonToolbar style={{ '--background': 'transparent', padding: 0 }}>
                  <IonTitle color="primary" className="bold">
                    Compromisos de pago
                  </IonTitle>
                  <IonButton color="danger"  fill="solid" size="small"  onClick={handleClickVencidas}
                       style={{ marginTop: '15px', height: '30px', marginLeft: '20px', }}
                  >
                    Vencidas
                  </IonButton>

                  <IonButtons slot="end" style={{ display: 'flex', gap: '12px' }}>
                  <IonButton
                        fill="outline"
                        color="primary"
                        onClick={() => exportarTablaCompromisos(flujoDataPorEmpresa, semanas)}
                      >
                        <IonIcon icon={downloadOutline} />
                      </IonButton>

                        <IonButton onClick={() => setModalOpen(true)} color="primary" fill="outline">
                          Agregar pagos futuros
                        </IonButton>
                      </IonButtons>
                    </IonToolbar>
                  </IonCardHeader>

          <IonCardContent style={{ overflowX: "auto" }}>
      
            

            <IonModal isOpen={modalOpen} onDidDismiss={() => setModalOpen(false)}>
                <IonHeader>
                  <IonToolbar>
                    <IonTitle>Agregar pago futuro</IonTitle>
                    <IonButtons slot="end">
                      <IonButton onClick={() => setModalOpen(false)}>
                        <IonIcon icon={closeOutline} />
                      </IonButton>
                    </IonButtons>
                  </IonToolbar>
                </IonHeader>

                <IonContent className="ion-padding">
                  <IonGrid>
                    <IonRow>
                
                      <IonCol size="6">
                        <IonItem>
                          <IonLabel position="floating">Empresa</IonLabel>
                      <IonSelect
                            value={empresaSeleccionada}
                            onIonChange={(e) => setEmpresaSeleccionada(e.detail.value)}
                          >
                            {empresasDisponibles.map((empresa) => (
                              <IonSelectOption key={empresa.rut} value={empresa.rut}>
                                {empresa.nombre}
                              </IonSelectOption>
                            ))}
                          </IonSelect>

                        </IonItem>
                      </IonCol>
                      <IonCol size="6">
                        <IonItem>
                          <IonLabel position="floating">Item</IonLabel>
                          <IonInput value={item} onIonChange={(e) => setItem(e.detail.value!)} />
                        </IonItem>
                      </IonCol>

                     
                      <IonCol size="5">
                      <IonItem style={{ padding: '5px 0' }}>
                        <IonLabel style={{ marginRight: '10px' }} color="dark">
                          Fecha de pago:
                        </IonLabel>
                        <IonDatetimeButton datetime="datetimePago" />
                        <IonModal keepContentsMounted={true}>
                         <IonDatetime
                            id="datetimePago"
                            locale="es-CL"
                            presentation="date"
                            value={fecha}
                            min={fechaMinISO}
                            max={fechaMaxISO}
                            onIonChange={(e: any) => {
                              const value = e.detail.value;
                              if (typeof value === 'string') {
                                setFecha(value);
                              } else if (Array.isArray(value)) {
                                setFecha(value[0]);
                              }
                            }}
                          />

                        </IonModal>
                      </IonItem>

                      </IonCol>

                      <IonCol size="4">
                        <IonItem>
                          <IonLabel position="floating">Monto</IonLabel>
                          <IonInput
                            type="number"
                            value={monto}
                            onIonChange={(e) => setMonto(Number(e.detail.value))}
                          />
                        </IonItem>
                      </IonCol>

                      <IonCol size="3">
                        <IonItem>
                          <IonLabel position="floating">Moneda</IonLabel>
                          <IonSelect value={moneda} onIonChange={(e) => setMoneda(e.detail.value)}>
                            <IonSelectOption value="CLP">CLP</IonSelectOption>
                            <IonSelectOption value="USD">USD</IonSelectOption>
                            <IonSelectOption value="EUR">EUR</IonSelectOption>
                            <IonSelectOption value="UF">UF</IonSelectOption>
                          </IonSelect>
                        </IonItem>
                      </IonCol>
                     </IonRow>
                      <IonCol size="12" className="ion-padding-top">
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                          <IonButton onClick={guardarPagoFuturo} color="primary">
                            Guardar
                          </IonButton>
                        </div>
                      </IonCol>
                   
                  </IonGrid>
                </IonContent>
            </IonModal>





            <table style={{ width: "max-content", borderCollapse: "collapse",  fontSize: "14px", }}>
            <thead>
              {/*  Fila 1: Agrupación por mes */}
              <tr>
                <th style={thStyle} rowSpan={2}>Empresa</th>
                <th style={thStyle} rowSpan={2}>Tipo</th>
                {semanasAgrupadas.map(({ mes, semanas }) => (
                  <th key={mes} colSpan={semanas.length} style={{ ...thStyle, textAlign: "center" as const }}>
                    {mes}
                  </th>
                ))}
              </tr>

              {/* 🔹 Fila 2: Semana por semana */}
             <tr>
  {semanas.map((semana, index) => (
    <th
      key={index}
      style={{
        ...thStyle,
      }}
    >
      {semana}
    </th>
  ))}
</tr>
              
            </thead>
<tbody>
  {flujoDataPorEmpresa.map(({ empresa, data }, empresaIndex) => {
    const rowBackground = empresaIndex % 2 === 0 ? "#ffffff" : "#f5f5f5";

    const manualesDeEmpresa = data.flatMap((s) => s.manuales ?? []);
    const tiposManuales = manualesDeEmpresa.map((m, idx) => ({
      id: `manual-${idx}`,
      descripcion: m.descripcion
    }));

    const tiposParaMostrar = [
      "saldo",
      "pagar",
      "cobrar",
      "balanceBanco",
      ...tiposManuales.map((m) => m.id),
      "total"
    ];

    return (
      <>
        {tiposParaMostrar.map((tipo, tipoIndex) => (
          <tr
            key={`${empresa}-${tipo}`}
            style={{
              background: rowBackground,
              borderTop: tipoIndex === 0 ? "3px solid #999" : undefined
            }}
          >
            {tipoIndex === 0 && (
              <td
                style={{ ...empresaCellStyle, background: rowBackground }}
                rowSpan={tiposParaMostrar.length}
              >
                {empresa}
              </td>
            )}

            <td style={{ ...tdHeaderStyle, background: rowBackground }}>
              {(() => {
                if (tipo === "saldo") return "Saldo disponible";
                if (tipo === "balanceBanco") return "Balance Bancario";
                if (tipo === "total") return "Total";
                if (tipo === "pagar") return "A pagar";
                if (tipo === "cobrar") return "A cobrar";
                return tiposManuales.find((m) => m.id === tipo)?.descripcion || "Manual";
              })()}
            </td>

            {semanas.map((semana, semanaIndex) => {
              const semanaData = data.find((s) => s.semana === semana);

              if (tipo.startsWith("manual-")) {
                const idxManual = parseInt(tipo.replace("manual-", ""));
                const manual = manualesDeEmpresa[idxManual];
                const thisManual = semanaData?.manuales?.find(
                  (m) => m.descripcion === manual.descripcion
                );

                return (
                  <td
                    key={semanaIndex}
                    style={{
                      ...tdStyle,
                      padding: "4px 6px",
                       borderLeft: semanaIndex === 0 ? "1px solid #ccc" : "2px solid #333",
                    }}
                  >
                   <div style={{   display: "flex", justifyContent: "flex-start",  flexWrap: "nowrap", gap: "20px"}}>
                        {["UF", "CLP", "USD", "EUR"].map((moneda, idx, arr) => {
                          const monto = thisManual ? thisManual.montos[moneda as keyof MontoPorMoneda] ?? 0 : 0;
                          return (
                            <div
                              key={moneda}
                              style={{
                                width: "120px",
                                textAlign: "left",
                                whiteSpace: "nowrap",
                                borderRight: idx < arr.length - 1 ? "1px solid #333" : "none",
                                paddingRight: "5px",
                                marginRight: "5px"
                              }}
                            >
                              <strong>{moneda}:</strong>{" "}
                              {typeof monto === "number" ? formatear(monto) : "--"}
                            </div>
                          );
                        })}
                      </div>
                  </td>
                );
              }

              let valores: MontoPorMoneda = getEmptyMonto();

              if (tipo === "saldo") {
                valores = semanaData?.saldo ?? getEmptyMonto();
              } else if (tipo === "pagar" || tipo === "cobrar" || tipo === "total") {
                valores = semanaData?.[tipo] ?? getEmptyMonto();
              } else if (tipo === "balanceBanco") {
                valores = semanaIndex === 0 ? semanaData?.balanceBanco ?? getEmptyMonto(): getEmptyMonto();
              }

              return (
              <td key={semanaIndex} style={{ ...tdStyle, padding: "4px 6px", borderLeft: semanaIndex === 0 ? "1px solid #ccc" : "2px solid #333", }}>
                <div style={{ display: "flex", justifyContent: "flex-start",  flexWrap: "nowrap",  gap: "20px" }}>
                  {["UF", "CLP", "USD", "EUR"].map((moneda, idx, arr) => {
                  const valor = valores[moneda as keyof MontoPorMoneda];
                  const esClickeable = tipo === "pagar" || tipo === "cobrar";

            return (
<div
  key={moneda}
  style={{
    width: "120px",
    textAlign: "left",
    whiteSpace: "nowrap",
    borderRight: idx < arr.length - 1 ? "1px solid #333" : "none",
    paddingRight: "5px",
    marginRight: "5px",
    cursor:
      (tipo === "balanceBanco" && semanaIndex === 0) || esClickeable
        ? "pointer"
        : "default",
    transition: "background 0.2s",
  }}
  onMouseEnter={(e) => {
    if (
      (tipo === "balanceBanco" && semanaIndex === 0) ||
      esClickeable
    ) {
      (e.currentTarget as HTMLDivElement).style.background = "#e0e0e0";
    }
  }}
  onMouseLeave={(e) => {
    (e.currentTarget as HTMLDivElement).style.background = "transparent";
  }}
  onClick={() => {
    if (tipo === "balanceBanco" && semanaIndex === 0) {
      setDetalleBancarioEmpresa(empresa);
      
      setDetalleBancarioSemana(semanaData as SemanaData);

      setModalDetalleBancarioOpen(true);
    } else {
      const tipoAPI =
        tipo === "pagar"
          ? "S"
          : tipo === "cobrar"
          ? "C"
          : null;
      if (esClickeable && tipoAPI) {
        handleClickDetalle(empresa, tipoAPI, semana);
      }
    }
  }}
>
  <strong>{moneda}:</strong>{" "}
  {typeof valor === "number" ? formatear(valor) : "--"}
</div>

                      );
                    })}
                  </div>
                </td>
              );
            })}
          </tr>
        ))}
      </>
    );
  })}
</tbody>








            </table>
          </IonCardContent>
       </IonCard>
  )}
      </IonContent>



      <IonModal isOpen={modalDetalleOpen} onDidDismiss={() => setModalDetalleOpen(false)}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>
            {detalleEmpresa} - Semana {detalleSemana} - {detalleTipo === "S" ? "Por Pagar" : "Por Cobrar"}
          </IonTitle>
          <IonButtons slot="end">
            <IonButton
              onClick={() =>
                exportarDetalleAExcel(
                  detalleEmpresaSeleccionada,
                  detalleEmpresa,
                  detalleSemana
                )
              }
            >
              <IonIcon slot="icon-only" icon={downloadOutline} />
            </IonButton>
            <IonButton onClick={() => setModalDetalleOpen(false)}>
              <IonIcon slot="icon-only" icon={closeOutline} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
<IonContent className="ion-padding">
  {loadingDetalle ? (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
      <IonLoading
        isOpen={loadingDetalle}
        message="Cargando detalle..."
        spinner="dots"
      />
    </div>
  ) : detalleEmpresaSeleccionada.length === 0 ? (
    <p>No hay datos disponibles.</p>
  ) : (
    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
      <thead>
        <tr>
          <th style={thTable}>Proveedor</th>
          <th style={thTable}>Moneda</th>
          <th style={thTable}>Monto Factura</th>
          <th style={thTable}>Pagado</th>
            {detalleTipo === "C" && (
          <th style={thTable}>Acciones</th>
           )}
        </tr>
      </thead>
          <tbody>
            {detalleEmpresaSeleccionada.map((item, index) => {
              const folio = item.Folio;
              const filaSeleccionada = folio === folioSeleccionado;

              return (
                <tr
                  key={index}
                  style={{ background: filaSeleccionada ? "#ffe5e5" : "transparent" }}
                >
                  <td style={tdTable}>{item.CardName}</td>
                  <td style={tdTable}>{item.MONEDA}</td>
                  <td style={tdTable}>{item["MONTO FACTURA"]?.toLocaleString()}</td>
                  <td style={tdTable}>{item.PAGADO?.toLocaleString()}</td>

                  {detalleTipo === "C" && (
                    <td style={tdTable}>
                      <IonCheckbox
                        checked={filaSeleccionada}
                        onIonChange={(e) => toggleSeleccionExcepcion(e.detail.checked, folio)}
                      />
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
    </table>
  )}

{folioSeleccionado && (
  <div style={{ marginTop: "45px" }}>
    <h5>Excepción factura N° {folioSeleccionado}</h5>
    <IonGrid>
      <IonRow>
        {/* Fecha */}
        <IonCol size="4">
          <IonItem style={{ padding: '5px 0' }}>
            <IonLabel style={{ marginRight: '10px' }} color="dark">
              Nueva fecha 
            </IonLabel>
            <IonDatetimeButton datetime="datetimeReprogramacion" />
            <IonModal keepContentsMounted={true}>
              <IonDatetime
                id="datetimeReprogramacion"
                locale="es-CL"
                presentation="date"
                value={fechaReprogramada}
                min={fechaMinISO}
                onIonChange={(e) => {
                  const value = e.detail.value;
                  if (typeof value === "string") {
                    setFechaReprogramada(value);
                  } else if (Array.isArray(value)) {
                    setFechaReprogramada(value[0]);
                  }
                }}
              />
            </IonModal>
          </IonItem>
        </IonCol>

        {/* Motivo */}
        <IonCol size="8">
          <IonItem>
            <IonLabel position="stacked">Motivo de reprogramación</IonLabel>
            <IonInput
              value={motivoExcepcion}
              placeholder="Ej.: Cliente avisó que pagará más adelante"
              onIonChange={(e) => setMotivoExcepcion(e.detail.value!)}
            />
          </IonItem>
        </IonCol>
      </IonRow>
    </IonGrid>

    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "16px" }}>
      <IonButton
        color="success"
        disabled={!fechaReprogramada || !motivoExcepcion || guardandoExcepcion}
        onClick={guardarExcepcionFactura}
      >
        Guardar excepción
      </IonButton>
      <IonButton
        color="medium"
        onClick={() => {
          setFolioSeleccionado(null);
          setFechaReprogramada("");
          setMotivoExcepcion("");
        }}
      >
        Cancelar
      </IonButton>
    </div>
  </div>
)}


</IonContent>
</IonModal>

 <IonModal
  isOpen={modalDetalleBancarioOpen}
  onDidDismiss={() => setModalDetalleBancarioOpen(false)}
>
  <IonHeader>
    <IonToolbar>
      <IonTitle>
        {detalleBancarioEmpresa} - Semana {detalleBancarioSemana?.semana} - Detalle Bancario
      </IonTitle>
    </IonToolbar>
  </IonHeader>
  <IonContent className="ion-padding">

    {/* Fondos por moneda */}
    {detalleBancarioSemana?.balanceBanco &&
      Object.entries(detalleBancarioSemana.balanceBanco).map(([moneda, valor]) => (
        <IonItem lines="none" key={moneda}>
          <IonIcon slot="start" name="ellipse" color="medium" style={{ fontSize: '8px' }} />
          <IonLabel>
            Fondos {moneda}: {valor.toLocaleString("es-CL")}
          </IonLabel>
        </IonItem>
      ))}

    {/* Fondos mutuos */}
    <IonItem lines="none">
      <IonIcon slot="start" name="ellipse" color="medium" style={{ fontSize: '8px' }} />
      <IonLabel>
        Fondos Mutuos: $0
      </IonLabel>
    </IonItem>

    

    {/* Botón cerrar */}
    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "16px" }}>
      <IonButton onClick={() => setModalDetalleBancarioOpen(false)}>
        Cerrar
      </IonButton>
    </div>
  </IonContent>
</IonModal>

<IonModal isOpen={modalVencidasOpen} onDidDismiss={() => setModalVencidasOpen(false)}   style={{ '--width': '91vw', '--height': '40vw'}}>
  <IonHeader>
    <IonToolbar>
      <IonTitle>Facturas Vencidas</IonTitle>
      <IonButtons slot="end">
       <IonButton onClick={() => {
        setModalVencidasOpen(false);
        setPaginaActual(1);  }}> Cerrar</IonButton>
      </IonButtons>
    </IonToolbar>
  </IonHeader>

  <IonContent>
  {isLoadingVencidas ? (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
      <IonSpinner name="crescent" />
      <p style={{ marginTop: '1rem' }}>Cargando facturas vencidas...</p>
    </div>
  ) : (
    <>

      <IonCardHeader>
        <IonCardSubtitle>Total de facturas</IonCardSubtitle>
      </IonCardHeader>

       <IonCard>
     

      <IonCardContent>
        <IonGrid >
        <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          fontSize: '12px'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#f1f1f1' }}>
              <th style={{ padding: '10px', minWidth: '100px', textAlign: 'left' }}>Empresa</th>
              <th style={{ padding: '10px', minWidth: '80px', textAlign: 'left' }}>Tipo</th>
              <th style={{ padding: '10px', minWidth: '200px', textAlign: 'left' }}>CardName</th>
              <th style={{ padding: '10px', minWidth: '100px', textAlign: 'right' }}>Folio</th>
              <th style={{ padding: '10px', minWidth: '100px', textAlign: 'right' }}>Monto</th>
              <th style={{ padding: '10px', minWidth: '80px', textAlign: 'center' }}>Moneda</th>
              <th style={{ padding: '10px', minWidth: '100px', textAlign: 'center' }}>Acciones</th>
            </tr>
          </thead>
       
         <tbody>
            {facturasPagina.map((item: any, i: number) => (
              <tr key={`${paginaActual}-${i}`} style={{ borderBottom: '1px solid #ccc' }}>
                <td style={{ padding: '8px' }}>{item.empresaName}</td>
                <td style={{ padding: '8px' }}>{item.TIPO === "S" ? "Pago" : "Cobro"}</td>
                <td style={{ padding: '8px' }}>{item.CardName}</td>
                <td style={{ padding: '8px', textAlign: 'right' }}>{item.Folio}</td>
                <td style={{ padding: '8px', textAlign: 'right' }}>{Number(item["MONTO FACTURA"]).toLocaleString()}</td>
                <td style={{ padding: '8px', textAlign: 'center' }}>{item.MONEDA}</td>
                <td style={{ padding: '8px', textAlign: 'center' }}>
                  {item.TIPO === "C" && (
                    <IonCheckbox
                      checked={folioSeleccionado === item.Folio}
                      onIonChange={(e) => toggleSeleccionExcepcion(e.detail.checked, item.Folio)}
                    />
                  )}
        </td>
      </tr>
    ))}
        </tbody>
      </table>
<IonRow className="pagination-row" style={{ marginTop: '1rem', justifyContent: 'center' }}>
  <IonButton
    onClick={() => setPaginaActual(paginaActual - 1)}
    disabled={paginaActual === 1}
    size="small"
  >
  «
  </IonButton>
  <IonLabel style={{ padding: "0 10px" }}>
    Página {paginaActual} de {totalPaginas}
  </IonLabel>
  <IonButton
    onClick={() => setPaginaActual(paginaActual + 1)}
    disabled={paginaActual === totalPaginas}
    size="small"
  >
     »
  </IonButton>
</IonRow>

        </IonGrid>
      </IonCardContent>
    </IonCard>

    {folioSeleccionado && (
      <IonCard style={{ marginTop: '20px' }}>
        <IonCardHeader>
          <IonCardSubtitle>Excepción factura N° {folioSeleccionado}</IonCardSubtitle>
        </IonCardHeader>
        <IonCardContent>
          <IonGrid>
            <IonRow>
              <IonCol size="4">
                <IonItem>
                  <IonLabel color="dark">Nueva fecha</IonLabel>
                  <IonDatetimeButton datetime="datetimeReprogramacionVencida" />
                  <IonModal keepContentsMounted={true}>
                    <IonDatetime
                      id="datetimeReprogramacionVencida"
                      locale="es-CL"
                      presentation="date"
                      value={fechaReprogramada}
                      min={fechaMinISO}
                      onIonChange={(e) => {
                        const value = e.detail.value;
                        if (typeof value === "string") {
                          setFechaReprogramada(value);
                        } else if (Array.isArray(value)) {
                          setFechaReprogramada(value[0]);
                        }
                      }}
                    />
                  </IonModal>
                </IonItem>
              </IonCol>
              <IonCol size="8">
                <IonItem>
                  <IonLabel position="stacked">Motivo</IonLabel>
                  <IonInput
                    value={motivoExcepcion}
                    placeholder="Ej.: Cliente pidió más plazo"
                    onIonChange={(e) => setMotivoExcepcion(e.detail.value!)}
                  />
                </IonItem>
              </IonCol>
            </IonRow>
          </IonGrid>

          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "16px" }}>
            <IonButton
              color="success"
              disabled={!fechaReprogramada || !motivoExcepcion || guardandoExcepcion}
              onClick={guardarExcepcionFacturaVencidas}
            >
              Guardar excepción
            </IonButton>
            <IonButton
              color="medium"
              onClick={() => {
                setFolioSeleccionado(null);
                setFechaReprogramada("");
                setMotivoExcepcion("");
              }}
            >
              Cancelar
            </IonButton>
          </div>
        </IonCardContent>
      </IonCard>
    )}
 </>
  )}
</IonContent>
</IonModal>



<IonAlert
  isOpen={alerta.abierto}
  onDidDismiss={() => setAlerta({ ...alerta, abierto: false })}
  header="Atención"
  message={alerta.mensaje}
  buttons={["OK"]}
/>

<IonAlert
  isOpen={alertaExcepcion.abierto}
  header="Atención"
  message={alertaExcepcion.mensaje}
  buttons={['OK']}
  onDidDismiss={async () => {
    setAlertaExcepcion({ ...alertaExcepcion, abierto: false });

    if (alertaExcepcion.mensaje === "Factura reprogramada correctamente.") {
      setFolioSeleccionado(null);
      setFechaReprogramada("");
      setMotivoExcepcion("");
      setModalDetalleOpen(false);
      await fetchDataFromEndpoint(); 
    }
  }}
/>

    </IonPage>



  );
};





const thTable = {
  border: "1px solid #ccc",
  padding: "4px",
  background: "#f0f0f0",
  textAlign: "left" as const,
};

const tdTable = {
  border: "1px solid #ccc",
  padding: "5px",
  textAlign: "left" as const,
};
// Estilos
const thStyle = {
  border: "1px solid #ccc",
  padding: "8px",
  background: "#f8f8f8",
  textAlign: "center" as const,
  whiteSpace: "nowrap" as const,
};
const thSemanaStyle = {
  ...thStyle,
  borderLeft: "3px solid #333", // más grueso y oscuro
};
const tdStyle = {
  border: "1px solid #ccc",
  padding: "8px",
  textAlign: "left" as const,
  whiteSpace: "nowrap" as const,
};

const tdHeaderStyle = {
  ...tdStyle,
  fontWeight: "bold",
  background: "#f0f0f0",
};

const empresaCellStyle = {
  border: "1px solid #ccc",
  padding: "8px",
  fontWeight: "bold",
  textAlign: "center" as const,
  verticalAlign: "middle" as const,
  background: "#e7e7e7",
  whiteSpace: "nowrap" as const,
};

    export default CompromisoPagoModulo;


